import { useEffect } from 'react';
import { useAuth } from 'app/domains/auth/hooks/useAuth';
import { AuthenticatedVar } from 'shared/domains/apollo/generated/types';
import { authenticatedVar, useAuthenticatedState } from 'shared/domains/apollo/utils/cacheVars';
const ONE_MINUTE = 60000;
export function useIsAccessTokenExpired() {
    const auth = useAuth();
    const authState = useAuthenticatedState();
    useEffect(() => {
        let controller = null;
        const interval = setInterval(() => {
            if (controller) {
                controller.abort();
            }
            controller = new AbortController();
            const { signal } = controller;
            auth.verifySession(signal).then((active) => {
                if (!active && !signal.aborted) {
                    authenticatedVar(AuthenticatedVar.NotAuthenticated);
                }
            });
        }, ONE_MINUTE);
        return () => {
            if (controller) {
                controller.abort();
            }
            clearInterval(interval);
        };
    }, [auth]);
    const isAccessTokenExpired = authState === AuthenticatedVar.NotAuthenticated;
    return { isAccessTokenExpired };
}
